import { useEffect, useState } from "react";
import CapturaCamara from "../CapturaCamara/CapturaCamara";
import { ContainerLayoutCamera } from "./localStyle";
import { getLocalStorage } from "global/utils/safeJsonParse";

// LayoutCamara: contenedor simple para mostrar títulos e integrar la captura.
// Muestra instrucciones iniciales y, luego de capturar, una pregunta de confirmación
// (gestionada por CapturaCamara).
// Los textos son parametrizables: por defecto hablan de "la orden" (caso FrenteOrden),
// pero AutorizacionOrden los reemplaza para hablar de "la autorización".
const LayoutCamara = ({
  onCapture,
  subtituloInicial = "Por favor posicione el frente de la orden debajo de la cámara y tome la foto.",
  tituloConfirmacion = "¿Se ve correctamente la orden?",
  subtituloConfirmacion = "Revise que la orden y lo solicitado se lean claramente",
}) => {
  const [step, setStep] = useState(0); // 0: instrucción; 1: confirmación visual
  const [title, setTitle] = useState("");
  const [subTitle, setSubTitle] = useState(subtituloInicial);
  const idTerminal = getLocalStorage("idTerminal");

  useEffect(() => {
    if (step === 1) {
      setTitle(tituloConfirmacion);
      setSubTitle(subtituloConfirmacion);
    } else {
      setTitle("");
      setSubTitle(subtituloInicial);
    }
  }, [step, subtituloInicial, tituloConfirmacion, subtituloConfirmacion]);

  return (
    <ContainerLayoutCamera $isTerminal={idTerminal}>
      <>
        {title && <h1>{title}</h1>}
        <span>{subTitle}</span>
      </>
      <CapturaCamara step={step} setStep={setStep} onCapture={onCapture} />
    </ContainerLayoutCamera>
  );
};

export default LayoutCamara;
